"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable import/no-extraneous-dependencies */
const react_1 = require("react");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_i18next_1 = require("react-i18next");
const ton_1 = require("ton");
const de_ui_1 = require("@delab-team/de-ui");
const smlAddr_1 = require("../../../../helpers/smlAddr");
const svg_selector_1 = require("../../../../assets/svg-selector");
const checkot_module_css_1 = __importDefault(require("./checkot.module.css"));
const pinpad_1 = require("../../../../components/pinpad");
const wallet_1 = require("../../../../logic/wallet");
const getClient_1 = require("../../../../utils/getClient");
const Checkout = (props) => {
    const TgObj = sdk_1.default;
    const [createAnimation, setCreateAnimation] = (0, react_1.useState)(undefined);
    const wall = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    const { t } = (0, react_i18next_1.useTranslation)();
    const fee = (0, ton_1.fromNano)('200000000');
    const tonBalanceTon = parseFloat(props?.walletBalanceTON?.replace(',', '.') ?? '0');
    function enableBtn() {
        TgObj.MainButton.enable();
        TgObj.MainButton.show();
        if (tonBalanceTon < Number(fee)) {
            TgObj.MainButton.text = t('common.fee-is-to-high');
            TgObj.MainButton.disable();
            TgObj.MainButton.color = '#424B56';
        }
        else if (!props.isSubmited) {
            TgObj.MainButton.color = '#007AFF';
            TgObj.MainButton.text = t('common.submit');
            TgObj.MainButton.enable();
        }
        else if ((props.isSubmited && props.isSended)) {
            TgObj.MainButton.text = t('swap-modal.sending-loading');
            TgObj.MainButton.color = '#424B56';
            TgObj.MainButton.disable();
        }
        // else {
        //     TgObj.MainButton.color = '#007AFF'
        //     TgObj.MainButton.text = t('main.send-btn2')
        //     TgObj.MainButton.enable()
        // }
    }
    const handleSend = async () => {
        const checkPsw = await wall.getPrivateKey(props.psw.value);
        if (typeof checkPsw === 'object') {
            setCreateAnimation('failure');
            return;
        }
        setCreateAnimation('success');
        TgObj.MainButton.showProgress();
        await props.transMakeToCompl();
    };
    (0, react_1.useEffect)(() => {
        if (props.psw.value.length === 4) {
            handleSend();
        }
    }, [props.psw.value.length, props.psw.value]);
    (0, react_1.useEffect)(() => {
        if (props.position !== 1)
            return;
        enableBtn();
        const handleBtnClick = () => {
            TgObj.HapticFeedback.impactOccurred('medium');
            if (!props.isSubmited) {
                props.setIsSubmited(true);
            }
            //  else {
            //     props.transMakeToCompl()
            // }
        };
        TgObj.MainButton.onClick(handleBtnClick);
        return () => {
            TgObj.MainButton.offClick(handleBtnClick);
        };
    }, [props.position === 1, props.psw.value, props.isSended, props.isSubmited]);
    return ((0, jsx_runtime_1.jsx)("div", { className: checkot_module_css_1.default.container, children: !props.isSubmited ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: checkot_module_css_1.default.modalTitle, children: t('send.checkout') }), (0, jsx_runtime_1.jsxs)("div", { className: checkot_module_css_1.default.top, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: checkot_module_css_1.default.youSend, children: t('trans-detail.you-send') }), (0, jsx_runtime_1.jsx)("div", { className: checkot_module_css_1.default.topAmountWrapper, children: (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: checkot_module_css_1.default.topAmount, children: props?.sendData?.nftTitle }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: checkot_module_css_1.default.info, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: checkot_module_css_1.default.detailsHeader, children: t('trans-detail.header') }), (0, jsx_runtime_1.jsxs)("div", { className: checkot_module_css_1.default.infoItem, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: checkot_module_css_1.default.infoItemLeft, children: t('trans-detail.address') }), (0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: checkot_module_css_1.default.infoItemRight, children: (0, smlAddr_1.smlAddrCheckout)(props?.sendData?.sendAddress) })] }), (0, jsx_runtime_1.jsx)("div", { className: checkot_module_css_1.default.dottedLine, children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "dotted-line" }) }), (0, jsx_runtime_1.jsxs)("div", { className: checkot_module_css_1.default.infoItem, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: checkot_module_css_1.default.infoItemLeft, tgStyles: { color: tonBalanceTon < Number(fee) ? '#FF3B30' : 'rgb(var(--placeholder-primary))' }, style: { color: tonBalanceTon < Number(fee) ? '#FF3B30' : '' }, children: t('trans-detail.fee') }), (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: checkot_module_css_1.default.infoItemRight, tgStyles: { color: tonBalanceTon < Number(fee) ? '#FF3B30' : 'rgb(var(--placeholder-primary))' }, style: { color: tonBalanceTon < Number(fee) ? '#FF3B30' : '' }, children: ["~ ", fee, " TON"] })] }), (0, jsx_runtime_1.jsx)("input", { type: 'text', placeholder: t('common.message'), className: checkot_module_css_1.default.messageInput, value: props.message.value, onChange: e => props.message.change(e.target.value), onFocus: (e) => {
                                e.preventDefault();
                                document.body.style.overflow = 'hidden';
                            } })] })] })) : (
        // <div className={s.passwordBlock} style={{ paddingBottom: props.isTg ? '50px' : '' }}>
        //     {/* <PasswordInput
        //         onChange={e => props.psw.change(e.target.value)}
        //         placeholder={t('common.password')}
        //         inputTitle={t('common.enter-password')}
        //     /> */}
        // </div>
        (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.enter'), onChange: e => props.psw.change(e), animationState: createAnimation, setAnimationState: setCreateAnimation })) }));
};
exports.Checkout = Checkout;
